import React from 'react';
import { Paragraph } from '@mlc/web-ui-toolkit';

type Props = {
	children: string;
};

const FieldLabel = (props: Props) => {
	return (
		<Paragraph fontSize="lead" fontWeight="semibold" className="fieldLabel">
			{props.children}
		</Paragraph>
	);
};

export default FieldLabel;
